let _ = require('lodash');
let moment = require('moment');
//import { getHighchartLanguageOptions } from "@/main";

// opts.series[0].data = _.map(data[tierNumber], function (item) {
//     return {
//         name: item.name, percent: item.percent, memberCount: item.memberCount, y: item.total, color: elvenStats.getColorFromGoodType(
//             item.name), drilldown: item.name
//     };
// });

/**
 * Converts the data array to a highcharts compatible timeseries
 *
 * For data like: [{time: 1514433600000, open: 200.0}... you'd specify "time" for dateProperty, open for yProperty
 *
 * ```
 * var data = [{1514433600000, open: 200.0}, {1514433600001, open: 205.0}];
 * exports.convertToHighChartsTimeSeries(data, "time", "open")    // returns [[1514433600000, 200.0], [1514433600001, 205.0]]
 * ```
 *
 * @param {Array} data an array of objects
 * @param dateProperty - property can be a Date or unix timestamp
 * @param yProperty
 * @param {Date} minDate - dates must be greater than this date or they will be filtered out.
 */
exports.convertToHighChartsTimeSeries = function(data, dateProperty, yProperty, minDate ) {
    let minDateUnix = moment(minDate||new Date()).unix()*1000;
    return _.compact( _.map(data, function(item,index) {
        let theDate = item[dateProperty];
        // if( !theDate ) {
        //     throw new Error("Date Property doesn't exist at index: " + index + " object: " + JSON.stringify(item) );
        // }

        if( _.isDate(theDate) ) {
            theDate = moment(theDate).unix()*1000;
        }

        if( _.isString(theDate) ) {
            theDate = moment(theDate).unix()*1000;
        }

        if( theDate > minDateUnix ) {
            return [ theDate, Number(item[yProperty]) || 0 ];
        }
    }));
};

exports.getTournamentHighChartsTimeSeries = function(data, minDate, i18n ) {
    minDate = minDate || new Date(2017, 12, 1);
    let minDateUnix = moment(minDate).unix()*1000;
    let dateProperty = "date";
    let yProperty = "points";

    return _.compact( _.map(data, function(item,index) {
        let theDate = item[dateProperty];
        // if( !theDate ) {
        //     throw new Error("Date Property doesn't exist at index: " + index + " object: " + JSON.stringify(item) );
        // }

        if( _.isDate(theDate) ) {
            theDate = moment(theDate).unix()*1000;
        }

        if( _.isString(theDate) ) {
            theDate = moment(theDate).unix()*1000;
        }

        if( theDate > minDateUnix ) {
            let temp = {
                x: theDate,
                y: Number(item[yProperty]) || 0,
                color: exports.getColorFromGoodType(item.relic),
                name: i18n.t( `site.common.${item.relic}`),
                relic: item.relic,
                drilldown: moment(theDate).format("YYYYMMDD"),
                rank: Number(item["rank"])
            };
            if( item.chests ) {
                temp.chests = item.chests;
            }
            return temp;
        }
    }));
};

exports.getColorFromGoodType = function getColorFromGoodType(goodName) {
    switch (goodName) {
        case 'marble':
            return "#FBF8E4";
        case 'steel':
            return "#2C2F36";
        case 'planks':
            return "#BC7A15";
        case 'crystal':
            return "#79CCD5";
        case 'scrolls':
            return "#F3D5A3";
        case 'silk':
           return "#C91300";
            // return '#DF9D17'
        case 'elixir':
            return "#FF8791";
        case 'magic_dust':
        case 'dust':
            return "#E4A8DD";
        case 'gems':
            return "#BB2F93";
        case 'moonstone':
            return "#D4D1C4";
        case 'platinum':
            return "#919FB2";
        case 'gum':
        case 'elven_tree_gum':
            return "#49B138";
        default:
            return "#D9BE92";
    }
};

/**
 * Creates the tournament history chart
 * @param player - either a User or Fellowship object (which has the property, tournaments)
 * @param i18n
 * @param highCharts
 * @param minDate
 * @param [players] - optional, if present it creates a drilldown on the chart (used when generating the fellowship variant)
 * @returns {{title: {text}, chart: {type: string, panning: boolean, panKey: string, zoomType: string, height: number, alignTicks: boolean}, yAxis: *[], xAxis: {type: string}, legend: {layout: string, align: string, verticalAlign: string}, tooltip: {split: boolean, shared: boolean}, plotOptions: {candlestick: {color: string, upColor: string}, series: {}}, series: *[], rangeSelector: {buttons: *[], selected: number}, lang: {decimalPoint: string, thousandsSep: string}, responsive: {rules: *[]}}}
 */
exports.getTournamentHistoryChart = function( player, i18n, highCharts, minDate, players ) {

    // try {
    //     console.log("moment locale in getTournamentHistoryChart", moment.locale());
    //     let temp = getHighchartLanguageOptions();
    //     console.log(temp);
    //     highCharts.setOptions( temp );
    // }catch(err) {
    //     console.log("Failed to set highcharts options", err);
    // }

    let tournamentScore = exports.getTournamentHighChartsTimeSeries(player.tournaments, minDate, i18n);

    let opts = {
        title: {
            text: i18n.t('site.common.tournamentHistory'),
        },
        chart: {
            type: 'line',
            panning: true,
            panKey: 'shift',
            zoomType: 'xy',
            height: 300,
            alignTicks: true,

        },
        yAxis: [
            {
                startOnTick: false,
                endOnTick: false,
                labels: {
                    align: 'right',
                    x: -3
                },
                title: {
                    text: i18n.t('site.common.points')
                },
                height: '100%',
                lineWidth: 2,
                resize: {
                    enabled: true
                },
                opposite: false,
            }
        ],
        xAxis: {
            type: 'datetime',
        },
        legend: {
            layout: 'horizonal',
            align: 'center',
            verticalAlign: 'bottom',
        },
        subtitle: {
            text: i18n.t('site.fellowship.barCharts.clickSlice'),
        },
        tooltip: {
            formatter: function () {
                console.log("in formmater: ", this.point);
                var str = "";

                if( this.point.relic ) {
                    str += `<center><img src="/static/img/icons/${this.point.relic}.png" width=24></center>`;
                }else {
                    str +=  `<strong> ${this.point.name}</strong><BR/>`;
                }
                str += this.point.y ? `<img src="/static/img/icons/ranking_points.png" width=24>: <strong>${this.point.y}</strong>` : "";
                str += this.point.chests ? `<br/><img src="/static/img/icons/chests.png" width=24>: <strong>${this.point.chests}</strong>` : "";
                str += this.point.rank ? `<br/><img src="/static/img/icons/rank2.png" width="24">: <strong>${this.point.rank}</strong>` : "";
                str += "<br/><small>" +  (moment.utc(this.point.date || this.point.x).format("LL")) + "</small>";
                return str;
            },
            useHTML: true,
            // pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        // tooltip: {
        //     split: false,
        //     shared: true,
        // },
        plotOptions: {
            candlestick: {
                color: 'red',
                upColor: 'lightgreen'
            },
            series: {
                // dataGrouping: {
                //     units: groupingUnits
                // }
            }
        },
        series: [
            {
                type: 'column',
                name: i18n.t('site.common.tournament'),
                id: 'tournament',
                zIndex: 0,
                data: tournamentScore,
                visible: true,
                borderColor: '#909090',
                borderWidth: 1
            }],
        rangeSelector: {
            buttons: [{
                type: 'day',
                count: 3,
                text: '3d'
            }, {
                type: 'week',
                count: 1,
                text: '1w'
            }, {
                type: 'month',
                count: 1,
                text: '1m'
            }, {
                type: 'month',
                count: 6,
                text: '6m'
            }, {
                type: 'year',
                count: 1,
                text: '1y'
            }, {
                type: 'all',
                text: 'All'
            }],
            selected: 1
        },
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 1000
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }
    };
    // console.log(JSON.stringify(tournamentScore, null, 3));

    if( players ) {
        opts.chart.events = {
            drilldown: function (options) {
                console.log("drill down event fired");

                //this.xAxis.labels.formatter = function() { return this.value; }
                //this.xAxis.labels.useHTML = false;
                this.update({xAxis: {type: "category"}});
            },
            drillup: function () {
                console.log("drill up event fired");
                this.update({xAxis: {type: "datetime"}});
            }
        };

        opts.drilldown = {
            drillUpButton: { position: { y: -28, verticalAlign: "top", x: -5 } },
            labels: {
                formatter: function () {
                    return this.value;
                },
                useHTML: false,
            },
            series: _.map(opts.series[0].data, function ( point ) {
                return {
                    id: point.drilldown,
                    name: point.name,
                    type: 'column',
                    data: _.orderBy(_.compact(_.map(players, function ( player ) {

                        let temp = _.find(player.tournaments, function ( t ) {
                            return moment.utc(t.date).format("YYYYMMDD") === point.drilldown;
                        });
                        return { name: player.username, y: temp && temp.points || 0, date: point.drilldown};
                    })), "y", "desc")
                };
            })
        };
    }

    //console.log( "drildown for tournament", opts );

    return opts;
}

exports.getScoreHistoryChart = function( player, i18n, highCharts, minDate ) {

    let rankingScore = exports.convertToHighChartsTimeSeries(player.scoreHistory, "date", "score", minDate );

    let opts = {
        title: {
            text: i18n.t('site.common.scoreHistory'),
        },
        chart: {
            type: 'line',
            panning: true,
            panKey: 'shift',
            zoomType: 'xy',
            height: 300,
            alignTicks: true,
        },
        yAxis: [
            {
                startOnTick: false,
                endOnTick: false,
                labels: {
                    align: 'right',
                    x: -3
                },
                title: {
                    text: i18n.t('site.common.score')
                },
                height: '100%',
                lineWidth: 2,
                resize: {
                    enabled: true
                },
                opposite: false,
            }
        ],
        xAxis: {
            type: 'datetime',
        },
        legend: {
            layout: 'horizonal',
            align: 'center',
            verticalAlign: 'bottom',
        },
        tooltip: {
            split: false,
            shared: true,
        },
        plotOptions: {
            candlestick: {
                color: 'red',
                upColor: 'lightgreen'
            },
            series: {
                // dataGrouping: {
                //     units: groupingUnits
                // }
            }
        },
        series: [{
            type: 'spline',
            name: i18n.t('site.common.score'),
            id: 'score',
            zIndex: 0,
            data: rankingScore,
            visible: true,
        }],
        rangeSelector: {
            buttons: [{
                type: 'day',
                count: 3,
                text: '3d'
            }, {
                type: 'week',
                count: 1,
                text: '1w'
            }, {
                type: 'month',
                count: 1,
                text: '1m'
            }, {
                type: 'month',
                count: 6,
                text: '6m'
            }, {
                type: 'year',
                count: 1,
                text: '1y'
            }, {
                type: 'all',
                text: 'All'
            }],
            selected: 1
        },
        lang: {
            decimalPoint: '.',
            thousandsSep: ','
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 1000
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        }
    };
    // console.log( JSON.stringify(tournamentScore, null, 3) );

    return opts;
};



// WEBPACK FOOTER //
// ./src/lib/elven-charts.js